import * as React from 'react';

import Simulator from './simulator';
import Widgets from './widgets';

import './index.less';

export default class WorkspacePane extends React.Component {
  public render() {
    return (
      <div className='engine-pane engine-workspacepane'>
        <Simulator />
        <Widgets />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./lib/engine/ui/panes/workspacepane/index.tsx